import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom';
import { LoadingCard } from 'adc-ui-components';
import ErrorBoundary from './components/ErrorBoundary';
import {
  HOME,
  AUTOPAY,
  METHODS,
  NEW_PAYMENT,
  COLLECTIONS,
  SCHEDULED_PAYMENT,
  ARRANGEMENT,
  PAYMENT_SETUP,
  TERMS_AUTOPAY,
  TERMS_STORED_PAYMENT,
  TERMS_ECOBILL,
  PAYMENT_PLAN,
  NOW_METHODS,
  NO_XFINITY_SERVICES,
  NO_NOW_SERVICES,
  NO_CONTACT_ERROR,
  MOBILE_METHODS,
  MOBILE_NEW_PAYMENT,
  MOBILE_NEW_PAYMENT_METHOD,
  MOBILE_AUTOPAY,
  MOBILE_DEVICE_NEW,
  MOBILE_MAINTENANCE_ERROR,
  NO_MOBILE_SERVICES,
  INSTALLMENT,
  MOBILE_ARRANGEMENT,
  SERVICE_RECOVERY,
} from './helpers/routes';
import { flagEnabled } from './helpers/featureFlags';

const DefaultLayout = lazy(() => import('./containers/Layouts/DefaultLayout'));
const DefaultLayoutWithTracking = lazy(() => import('./containers/Layouts/DefaultLayoutWithTracking'));
const NewPayment = lazy(() => import('./containers/NewPayment'));
const Collections = lazy(() => import('./containers/Collections'));
const AutopaySignup = lazy(() => import('./containers/AutopaySignup'));
const Autopay = lazy(() => import('./containers/Autopay'));
const Methods = lazy(() => import('./containers/ManageInstruments'));
const Wallet = lazy(() => import('./containers/MobileWallet'));
const ScheduledPayment = lazy(() => import('./containers/Scheduled'));
const Arrangement = lazy(() => import('./containers/Arrangement'));
const Installment = lazy(() => import('./containers/Plans/Installment'));
const NoMatch = lazy(() => import('./containers/Errors/NoMatch'));
const Terms = lazy(() => import('./containers/Terms'));
const PaymentPlan = lazy(() => import('./containers/PaymentPlan'));
const NoServices = lazy(() => import('./containers/Errors/NoServices'));
const StepUpError = lazy(() => import('./containers/Errors/StepUpError'));
const MobileNewPayment = lazy(() => import('./containers/MobileNewPayment'));
const MobileAutopay = lazy(() => import('./containers/MobileAutopay'));
const MobileNewDevice = lazy(() => import('./containers/MobileDeviceNew'));
const SafeConnectionsError = lazy(() => import('./containers/Errors/SafeConnectionsError'));
const MobileArrangement = lazy(() => import('./containers/MobileArrangement'));
const ServiceRecovery = lazy(() => import('./containers/Plans/ServiceRecovery'));

const AppRoutes = props => (
  <ErrorBoundary>
    <Suspense fallback={<LoadingCard />}>
      <Switch>
        <DefaultLayout exact path={HOME} component={ScheduledPayment} {...props} />
        <DefaultLayout path={NEW_PAYMENT} component={NewPayment} {...props} />
        {flagEnabled('global.collections2', { defaultValue: true }) && <DefaultLayout path={COLLECTIONS} component={Collections} {...props} />}
        <DefaultLayout path={PAYMENT_PLAN} component={PaymentPlan} {...props} />
        <DefaultLayout path={SCHEDULED_PAYMENT} component={ScheduledPayment} {...props} />
        <DefaultLayout path={ARRANGEMENT} component={Arrangement} {...props} />
        <DefaultLayout path={INSTALLMENT} component={Installment} {...props} />
        {flagEnabled('serviceRecoveryEnabled') && (
          <DefaultLayout path={SERVICE_RECOVERY} component={ServiceRecovery} {...props} />
        )}
        <DefaultLayoutWithTracking path={PAYMENT_SETUP} component={AutopaySignup} {...props} />
        <DefaultLayoutWithTracking path={NO_XFINITY_SERVICES} component={NoServices} productClass="Xfinity" {...props} />
        <DefaultLayoutWithTracking path={NO_NOW_SERVICES} component={NoServices} productClass="NOW" {...props} />
        <DefaultLayout path={[METHODS, NOW_METHODS]} component={Methods} {...props} />
        <DefaultLayout path={MOBILE_METHODS} component={Wallet} {...props} />
        <DefaultLayout
          path={[MOBILE_NEW_PAYMENT, MOBILE_NEW_PAYMENT_METHOD]}
          component={MobileNewPayment}
          {...props}
        />
        <DefaultLayout path={MOBILE_DEVICE_NEW} component={MobileNewDevice} {...props} />
        <DefaultLayout path={MOBILE_AUTOPAY} component={MobileAutopay} {...props} />
        {flagEnabled('xmPaymentArrangementEnabled') && (
          <DefaultLayout path={MOBILE_ARRANGEMENT} component={MobileArrangement} {...props} />
        )}
        <DefaultLayoutWithTracking
          path={MOBILE_MAINTENANCE_ERROR}
          component={SafeConnectionsError}
        />
        <DefaultLayoutWithTracking path={NO_MOBILE_SERVICES} component={NoServices} productClass="Xfinity Mobile" />
        <DefaultLayout path={AUTOPAY} component={Autopay} {...props} />
        <DefaultLayoutWithTracking path={TERMS_AUTOPAY} component={Terms} contractId="autopay" {...props} />
        <DefaultLayoutWithTracking path={TERMS_STORED_PAYMENT} component={Terms} contractId="stored-payment" {...props} />
        <DefaultLayoutWithTracking path={TERMS_ECOBILL} component={Terms} contractId="ecobill" {...props} />
        <DefaultLayoutWithTracking path={NO_CONTACT_ERROR} component={StepUpError} {...props} />
        <DefaultLayoutWithTracking component={NoMatch} {...props} />
      </Switch>
    </Suspense>
  </ErrorBoundary>
);

export default AppRoutes;
